(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('PhysicalFairEventVenueFormController', PhysicalFairEventVenueFormController)

    PhysicalFairEventVenueFormController.$inject = ['$uibModal', '$state', 'toastr', 'ExpoService', 'cities', 'eventVenue'];


    function PhysicalFairEventVenueFormController($uibModal, $state, toastr, ExpoService, cities, eventVenue) {
        var vm = this;

        vm.queryFlag                    = false;
        vm.cities                       = cities;
        vm.eventVenue                   = eventVenue;
        vm.mountForm                    = mountForm;
        vm.changeAddress                = changeAddress;
        vm.save                         = save;
        vm.goToList                     = goToList;
        vm.flag                         = true;


        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;


        vm.place = ''

        vm.form = {
            name: '',
            expo_city_id: '',
            longitude: '',
            latitude: '',
            address: ''
        }

        function changeAddress() {
            if (vm.place.geometry !== undefined) {
                vm.form.name = vm.place.name
                vm.form.address = vm.place.formatted_address
                vm.form.neighborhood = vm.place.address_components[1].long_name
                vm.form.zipcode = vm.place.address_components[5].long_name
                vm.form.website = vm.place.website
                vm.form.phone = vm.place.international_phone_number
                vm.form.latitude = vm.place.geometry.location.lat()
                vm.form.longitude = vm.place.geometry.location.lng()
            }
            
        }

        function mountForm() {

            if (!vm.eventVenue) {
                return
            }

            vm.form.id = vm.eventVenue.id
            vm.form.name = vm.eventVenue.name
            vm.form.expo_city_id = vm.eventVenue.expo_city_id
            vm.form.address = vm.eventVenue.address
            vm.form.neighborhood = vm.eventVenue.neighborhood
            vm.form.zipcode = vm.eventVenue.zipcode
            vm.form.website = vm.eventVenue.website
            vm.form.phone = vm.eventVenue.phone
            vm.form.latitude = vm.eventVenue.latitude
            vm.form.longitude = vm.eventVenue.longitude
        }
        
        function activate() {
            vm.mountForm()
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        async function goToList () {
            return await $state.go('root.physicalfairs.eventVenue');
        }

        async function save () {
            vm.flag = false;
            let fields = {};
            angular.copy(vm.form, fields);

            ExpoService.saveEventVenue(fields).then(function(response) {
                vm.flag = true;
                if(vm.eventVenue) {
                    toastr.success('Event venue successfully updated!');
                    vm.goToList();
                } else {
                    toastr.success('Event venue successfully created!');
                    vm.goToList();
                }
            })
        }

        activate();
    }

})();